<section class="contact-info-area pt-100 pb-70">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="contact-info-box mb-30">
          <div class="icon">
            <i class='bx bx-envelope'></i>
          </div>
          <h3>Пишите нам</h3>
          <p><a href="mailto:office@secom.kg">office@secom.kg</a></p>
          <p><a href="mailto:office@secom.kg"></a></p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
        <div class="contact-info-box mb-30">
          <div class="icon">
            <i class='bx bx-phone-call'></i>
          </div>
          <h3>Контакты</h3>
          <p><a href="tel:996702000474">0702 00 04 74</a> (тех.поддержка)</p>
          <p><a href="tel:996700220044">0700 22 00 44</a></p>
          <p><a href="tel:996550220044">0550 22 00 44</a></p>
          <p><a href="tel:996770220044">0770 22 00 44</a></p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="contact-info-box mb-30">
          <div class="icon">
            <i class='bx bx-map'></i>
          </div>
          <h3>Наш адрес</h3>
          <p><a href="https://goo.gl/maps/EyZ1wdTjMTpLfamAA" target="_blank">Ул. Байтик Баатыра (Советская) 71а пер.
            Кулатова</a></p>
        </div>
      </div>

    </div>
  </div>

  <div id="particles-js-circle-bubble-2"></div>
</section>

<div id="map">
  <iframe
    allowfullscreen=""
    aria-hidden="false" frameborder="0" height="450" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2924.5861772138355!2d74.60989524158644!3d42.86047039192541!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x389eb634a13a8b69%3A0xc243fc870ae343fe!2zIlNFQ09NIiDQntCR0KDQkNCX0J7QktCQ0KLQldCb0KzQndCe0JUg0KPQp9CV0KDQldCW0JTQldCd0JjQlSDQuNC8INCf0LDQv9C40YfQsA!5e0!3m2!1sen!2skg!4v1601861985776!5m2!1sen!2skg" style="border:0;" tabindex="0"
    width="600"></iframe>
</div>
